import { getAzureApiToken } from '@/helpers/azure/apiToken';

export const getUserList = () => getAzureApiToken()
  .then(token => fetch(`https://graph.microsoft.com/v1.0/groups/${process.env.REACT_APP_Co_Azure_ARSForms_Prod_App_Admin}/members`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }).then(res => res.json()));
